import React from 'react'
import KanBoIcon from 'components/KanBoIcon'
import User from 'components/ControlledUser'
import RelativeDate from 'components/RelativeDate'
import { ListItem } from 'components/List'
import { convertFromToUser } from 'utils/users'
import { FormattedMessage } from 'react-intl'
import getCharCount from 'components/RichText/utils/getCharCount'
import RichTextContent from 'components/RichText/Content'
import Info from 'components/Info'
import styled from 'styled-components'

const TypedRichTextContent: any = RichTextContent

const StyledInfo = styled(Info)`
  margin-left: 0.5em;
`

const TypedRelativeDate: any = RelativeDate

const BlockerInfo = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
`

const Text = styled.span`
  margin-right: 0.5em;
`

const Icon = styled.span`
  margin-right: 5px;
`

const ResponsibleUserAvatar = styled(User)`
  margin-right: 5px;
`

type Props = React.ComponentProps<typeof ListItem> & {
  component?: React.ComponentType<React.ComponentProps<typeof ListItem>>
  name: string;
  description?: any;
  creationDate: number;
  createdBy: string;
  reason?: string;
  userId?: number;
}

const CardBlocker: React.FC<Props> = ({
  component: Component = ListItem,
  name,
  description,
  creationDate,
  createdBy,
  reason,
  userId,
  ...props
}) => {
  const user = convertFromToUser(createdBy)

  const showUser = user && user.type === 'USER'

  return (
    <Component
      icon={
        <KanBoIcon name='kanbo-16-block' className='text-danger' />
      }
      subtitle={
        <>
          {reason}
          
          {userId && (
            <BlockerInfo>
              <Text>
                <FormattedMessage id='BLOCKERS_BLOCKED_BY' />
              </Text>
              <ResponsibleUserAvatar
                avatar
                id={userId}
                size={16}
              />
              <User
                text
                id={userId}
              />
            </BlockerInfo>
          )}
          <BlockerInfo>
            {showUser &&
              <>
                <Text>
                  <FormattedMessage id='BLOCKERS_CREATED_BY' />
                </Text>
                <Icon>
                  <User
                    avatar
                    id={user.id}
                    size={16}
                  />
                </Icon>
              </>
            }
            <TypedRelativeDate pastOnly timestamp={creationDate}>
              {({ dateMoment, nowMoment }) =>
                <span
                  title={dateMoment.format('LLLL')}
                >
                  {dateMoment.from(nowMoment)}
                </span>
              }
            </TypedRelativeDate>
          </BlockerInfo>
        </>
      }
      {...props}
    >
      {name}
      {(description && getCharCount(description) > 0) &&
        <StyledInfo>
          <TypedRichTextContent
            content={description}
          />
        </StyledInfo>
      }
    </Component>
  )
}

export default CardBlocker